export const getAPI = () => {
  return sessionStorage.getItem('OVERRIDE_API') ?? process.env.REACT_APP_BASE_URL
}

export const getStationId = () => {
  return sessionStorage.getItem('OVERRIDE_STATION_ID') ?? process.env.REACT_APP_STATION_ID
}
